import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A lesson about client-side templating",
  "description": "",
  "published": "2011-12-19T00:00:00.000Z",
  "redirect_from": ["/blog/a-lesson-about-client-side-templating/swizec/3208"],
  "categories": "Client-side, Clients, JavaScript, jQuery, Server, Uncategorized, Web page",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/4371042134_c7431995c4_m6.jpg",
        "alt": "Preona Muffin Making",
        "title": "Preona Muffin Making"
      }}></img></p>
    <p>{`The past few months have seen an explosion of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Client-side",
        "title": "Client-side"
      }}>{`client-side`}</a>{` MVC frameworks. `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Model%E2%80%93view%E2%80%93controller#JavaScript"
      }}>{`Wikipedia lists `}<em parentName="a">{`eleven`}</em>{` of these things`}</a>{`! And yet even a year ago the majority of developers was perfectly content with jQuery.`}</p>
    <p>{`But as browser apps become ever more powerful it only makes sense to realize callback soup isn't fun and `}<em parentName="p">{`hey, wasn't there some paradigm we use on `}{`[servers]`}{`(`}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Server"
        }}>{`http://en.wikipedia.org/wiki/Server`}</a></em>{`%28computing%29 "Server (computing)") to make this web insanity work?`}{`_`}{` Yeah, there is.`}</p>
    <p>{`A few months ago I gave a talk entitled `}<em parentName="p"><a parentName="em" {...{
          "href": "http://swizec.com/blog/webcamplj-was-bitchin/swizec/2696",
          "title": "#WebcampLj was bitchin’"
        }}>{`Tools that get you laid`}</a></em>{` at `}<a parentName="p" {...{
        "href": "http://webcamp.si/"
      }}>{`WebCamp Ljubljana`}</a>{`. The basic premise was that client-side MVC is so insanely awesome you are sure to get laid for using it. The main benefits I talked about were:`}</p>
    <ol>
      <li parentName="ol">{`Server is just a DB interface, means less melting servers`}</li>
      <li parentName="ol">{`Effect similar to progressive loading, means users `}<em parentName="li">{`see something immediately `}</em>{`- makes waiting easier`}</li>
      <li parentName="ol">{`Using powerful client machines to do the heavy UX lifting`}</li>
      <li parentName="ol">{`I may have had some other points :P`}</li>
    </ol>
    <h2 {...{
      "id": "the-lesson"
    }}>{`The lesson`}</h2>
    <p>{`The past four days have taught me an important lesson though - perhaps none of this is true.`}</p>
    <p>{`Since Thursday my blog has seen two months' worth of normal traffic - more about the shiny stats tomorrow - it was only natural that poor ol' `}<a parentName="p" {...{
        "href": "http://wordpress.org",
        "title": "WordPress"
      }}>{`wordpress`}</a>{` would crumble under the pressure ... right?`}</p>
    <p>{`Well, actualy, no, it totally shouldn't have. There's all this fancy caching going on that what readers see are pretty much just static pages. There's no more PHP or server involved!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-16-at-1.53.20-PM-300x175.png",
        "alt": "A stats screenie",
        "title": "A stats screenie"
      }}></img></p>
    <p>{`But none of that helped. Even redirecting the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Uniform_Resource_Locator",
        "title": "Uniform Resource Locator"
      }}>{`URL`}</a>{` with most traffic straight to the stored static page didn't help. Something strange was happening. Something strange happens `}<em parentName="p">{`every single time this blog gets some traffic`}</em>{`. This time it was particularly bad so I investigated.`}</p>
    <p>{`Turns out the problem is in the small bit of client-side templating I do in my footer.`}</p>
    <p>{`Because the pages are static, loading my latest foursquare checkin, the last four instagram pics, and the list of my github repos `}<em parentName="p">{`must`}</em>{` happen client-side. It would be stupid to generate all this server-side every time somebody visits my site.`}</p>
    <p>{`To achieve this I'm using jquery template, it's a bit archaic and I may have started working on the footer before finding out about backbone and other cool MVC frameworks ... but it works and it's so small I don't think it would even benefit much from using a framework. The basic premise of most javascript templating is simply substring replacement, like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<img title="\${the_title}" src="\${url_var}" alt="" />
`}</code></pre>
    <p>{`Everything marked as a variable gets replaced with its value and everyone can be happy.`}</p>
    <p>{`Try to guess what happens with that `}<em parentName="p">{`src="`}{`\\`}{`\\`}{`\\`}{`\${url_var}"`}</em>{` bit in there. Yep, the browser tries to load it. Firing a request to something that always returns at least a 404 after wordpress decides that, hey, this isn't something I know of!`}</p>
    <p>{`This means that the url is `}<em parentName="p">{`never`}</em>{` cached either server-side `}{`_`}{`or `}{`_`}{`client-side!`}</p>
    <p>{`Turns out my blog was firing two such requests every time somebody came to the page. Every. Single. Time! In the latest case this meant 8 useless request per second at its peak. To the point most of my site just started throwing a 500 error and only that one redirected static page was still up ...`}</p>
    <p>{`All I have to do now is find a permanent solution. Any ideas?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.rassemblr.com/2011/04/on-client-side-templating/"
        }}>{`On Client Side Templating`}</a>{` (rassemblr.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/5371763/web-application-architecture-implementing-mvc-in-the-browser-using-a-server-as-a"
        }}>{`Web application architecture: Implementing MVC in the browser using a server as a repository of data and templates`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://inessential.com/2011/12/13/apps_and_web_apps_and_the_future"
        }}>{`Apps and web apps and the future`}</a>{` (inessential.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=340db1bf-0c20-4550-b5c3-93a188eb8979",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      